import { render, staticRenderFns } from "./fhir-human-name.vue?vue&type=template&id=748f97f0&"
import script from "./fhir-human-name.vue?vue&type=script&lang=js&"
export * from "./fhir-human-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports